export class RedshiftIntegrationConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "clusterIdentifier",
            "baseName": "clusterIdentifier",
            "type": "string",
            "format": ""
        },
        {
            "name": "database",
            "baseName": "database",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RedshiftIntegrationConfig.attributeTypeMap;
    }
    constructor() {
    }
}
